module.exports = __webpack_public_path__ + "img/arrowdown.b241a11f.png";